import ReceiptData from './ReceiptData';

export default ReceiptData;
